import React from 'react'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { insightsRouteProps } from 'src/navigation/routeProps'
import InsightsPage from 'src/page-components/InsightsPage/InsightsPage'

const InsightsAppRoute: AppRoute = {
  id: AppLocation.Insights,
  routeProps: insightsRouteProps,
  component: <InsightsPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default InsightsAppRoute
